export default __webpack_public_path__ + "static/media/Icon feather-chevron-right.27aa3df5.svg";